import { PartnerLogoProps } from "@ctypes";
import { resolveLogoSize } from "@utils/logo";

const WIDTH = 570;
const HEIGHT = 542.101;

export const FlbWatermark = ({ className, style, width, height }: PartnerLogoProps) => {
  const size = resolveLogoSize({ width, height, naturalWidth: WIDTH, naturalHeight: HEIGHT });

  return (
    <svg
      width={size.width}
      height={size.height}
      viewBox="0 0 570 542.101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g id="redstar.svg">
      <path id="Vector" fillRule="evenodd" clipRule="evenodd" d="M0 207.079L285 300.4L218.022 207.474L285 0V300.4L570 207.079L351.978 207.474L285 300.4L461.147 542.101L393.378 334.891L285 300.4L108.853 542.101L285 413.603V300.4L176.622 334.891L0 207.079Z" fill="white" fillOpacity="0.04"/>
      <path id="Vector_2" fillRule="evenodd" clipRule="evenodd" d="M0 207.079L218.022 207.474L285 300.4L393.378 334.891L570 207.079L285 300.4L351.978 207.474L285 0V300.4V413.603L461.147 542.101L285 300.4L176.622 334.891L108.853 542.101L285 300.4L0 207.079Z" fill="white" fillOpacity="0.08"/>
      </g>
    </svg>
  );
};
